module.exports = __webpack_public_path__ + "img/about-us.a4d96e29.jpg";